import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randJSON } from "@ngneat/falso";

export const randJSONNodeDef = createNodeDef({
  type: "randJSON",
  displayName: "JSON",
  defaultName: "json",
  fields: [
    { type: DataFieldType.NUMBER, key: "minKeys", label: "Min" },
    { type: DataFieldType.NUMBER, key: "maxKeys", label: "Max" },
    { type: DataFieldType.NUMBER, key: "totalKeys", label: "Exact" },
  ],
  initialData: (): {
    minKeys?: number;
    maxKeys?: number;
    totalKeys?: number;
  } => ({
    minKeys: undefined,
    maxKeys: undefined,
    totalKeys: undefined,
  }),
  generate: ({ node }) => {
    return randJSON({
      minKeys: node.data.minKeys,
      maxKeys: node.data.maxKeys,
      totalKeys: node.data.totalKeys,
    });
  },
});
